/**
 * Customer Agent Detail route (CLA-470 / CLA-1006).
 *
 * Eagerly registers the `/clawinstall/dashboard/agents/$agentId` file route and
 * its `?tab=` search validator; the page component and its atom/RPC imports are
 * deferred to `.lazy.tsx` so the detail chunk (charts, activity, access) stays
 * out of the main customer-dashboard bundle. Nests under the `dashboard.tsx`
 * layout (owner-auth guard) and renders the phase-1 `CustomerAgent` design
 * component.
 *
 * The active tab lives in the URL — not a module atom — exactly as the sibling
 * configure route's `?section=` does, so deep-linking a tab renders it and
 * switching between agents never carries the previous agent's tab.
 *
 * @since 1.0.0
 */
import { createFileRoute } from "@tanstack/react-router";
import { type AgentDetailTab, isAgentDetailTab } from "~/lib/agent-detail-tab.ts";

/**
 * Validate the `?tab=` search param carrying the active agent-detail tab. A
 * known tab passes through; any other value falls back cleanly to an empty
 * search (the page then defaults to Overview).
 *
 * @since 1.0.0
 */
export const validateAgentDetailSearch = (
  search: Record<string, unknown>,
): { tab?: AgentDetailTab } => isAgentDetailTab(search["tab"]) ? { tab: search["tab"] } : {};

export const Route = createFileRoute("/clawinstall/dashboard/agents/$agentId")({
  validateSearch: validateAgentDetailSearch,
});
